import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["button", "children", "className", "href", "isSocial", "noStyle", "onClick", "onMouseDown", "rel", "target", "disableDefaultEventTracking", "trackId", "testId", "trackEvent"];
import * as React from 'react';
import classnames from 'classnames';
import { withEventTracking } from 'react-event-tracker';
import { onlyText } from 'react-children-utilities';
import { AnalyticsLocationConsumer } from '@latitude/analytics-location';
import { BUTTON_STYLE } from '@latitude/core/utils/constants';
import { StyledLink } from './Link.styled';
const isFile = href => /\.(exe|zip|wav|mp3|mov|mpg|avi|wmv|pdf|doc|docx|xls|xlsx|ppt|pptx)$/.test(href);
const isAbsoluteUrl = href => new RegExp('^(?:[a-z]+:)?//', 'i').test(href);
const isTel = href => href.startsWith('tel:');
const isEmail = href => href.startsWith('mailto:');
const isExternal = href => {
  if (!isAbsoluteUrl(href)) {
    return false;
  }
  const internalUrls = ['latitudepay.com', 'latitudepay.com.au', 'gemfinance.co.nz', 'gemcreditline.co.nz', 'latitudefinancial.com', 'latitudefinancial.com.au', 'latitude.veda.com.au', 'gomastercard.com.au', 'gemvisa.com.au', '28degreescard.com.au', 'buyersedge.com.au', 'interestfree.com.au', 'umiloans.com.au', 'genoapay.com', 'mypersonalloanapp.com', 'lfscnp.com', 'lfs.corefinance.io'];
  const url = new URL(href, window.location.href);
  return !internalUrls.reduce((previous, current) => previous || url.hostname.indexOf(current) !== -1, false);
};
const isFunnel = href => href.startsWith('https://cardapp.latitudefinancial.com/apply') || href.startsWith('https://motorapp.latitudefinancial.com.au') || href.startsWith('https://lfs-apply.mypersonalloanapp.com') || href.startsWith('https://apply.gemvisa.co.nz/eapps/faces/LongAppRetail/personal.xhtml');
export const Link = _ref => {
  let {
      button,
      children,
      className,
      href,
      isSocial = false,
      noStyle = false,
      onClick,
      onMouseDown,
      rel,
      target,
      disableDefaultEventTracking = false,
      trackId,
      testId,
      trackEvent
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const isUrlExternal = href && href.startsWith('http');
  const getRel = () => !rel && isUrlExternal && target === '_blank' ? 'noopener noreferrer' : rel;
  const getTarget = () => !target && isUrlExternal ? '_blank' : target;
  const handleOnClick = (event, location) => {
    if (disableDefaultEventTracking !== true && trackEvent) {
      let category = 'text-link';
      let action = 'internal-link';
      if (button) {
        category = 'button-link';
      }
      if (isSocial) {
        action = 'social-link';
      }
      if (isExternal(href)) {
        action = 'external-link';
      }
      if (isTel(href)) {
        action = 'phone-link';
        category = 'contact-us';
      }
      if (isEmail(href)) {
        action = 'email-link';
        category = 'contact-us';
      }
      if (isFunnel(href)) {
        action = 'application-link';
        category = 'cta';
      }
      if (!isFile(href)) {
        trackEvent({
          event: {
            category,
            action,
            label: onlyText(children),
            location
          }
        });
      }
    }
    if (onClick) {
      onClick(event);
    }
  };
  return /*#__PURE__*/React.createElement(AnalyticsLocationConsumer, null, location => /*#__PURE__*/React.createElement(StyledLink, Object.assign({
    className: classnames(trackId && 'trackcustomanalytics', className),
    href: href,
    rel: getRel(),
    target: getTarget(),
    button: button,
    "data-trackid": trackId,
    noStyle: noStyle,
    onClick: event => handleOnClick(event, location),
    onMouseDown: onMouseDown,
    "data-test-id": testId
  }, rest), children));
};
export default withEventTracking(Link);